import { useState, useEffect } from 'react';

export const useHydrationSafeDate = (date: string) => {
  const [safeDate, setSafeDate] = useState<Date | null>(null);

  useEffect(() => {
    if (date && window) {
      setSafeDate(new Date(date));
    }
  }, [date]);

  return safeDate;
};